<div class="modal-header bg-light border-light c-custom-modal-header--wrapper">
    <div class="modal-title pull-left">
        <h3 class="mb-0 font-weight-bold">Share Report Settings</h3>
        <small class="text-muted font-weight-bold"></small>
    </div>

    <button type="button" id="share-report-modal-close" (click)="showShareBsModalRef.hide()"
        class="close pull-right align-self-center" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-light">
    <div class="c-share-report-content--wrapper">
        <div class="c-share-report-content--box">
            <ng-container *ngIf="userService.checkOrganizationAdmin() || createdBy == userService.getUserId()">
                <h4 class="c-share-report-content--boxTitle">Please enter the User's name that you wish to share this report with</h4>
                <div class="search-field">
                    <app-custom-search-input #USER_NAME="ngModel" name="USER_NAME" delay="500" placeholder="Type Name here..."
                      (outValue)="autocompleteUsers($event)" [(ngModel)]="USER_NAME_MODEL"
                      (focusGained)="userAutoOpen = true" (focusLost)="userFocusLost()"
                      [hasResults]="userAutoOpen && userList?.length > 0 ? true : false"
                      [showLoading]="searchingUser">
                    </app-custom-search-input>

                    <div class="autocomplete custom__scroll input__search" *ngIf="userList?.length > 0 && userAutoOpen">
                      <ng-container *ngFor="let user of userList">
                        <div class="item" (click)="selectGenerator(user);">
                          {{user.NAME_FIRST}} {{user.NAME_LAST}}
                        </div>
                      </ng-container>
                    </div>
                </div>
                <!-- <div class="form-group">
                    <input type="text" class="input input__large input__blue w-75" placeholder="Enter Email"
                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"
                        [(ngModel)]="email" #USER_EMAIL="ngModel" maxlength="50" name="USER_EMAIL" required>
                    <button type="button" class="button primary__button share__button w-20 ml-4" (click)="callSharingApi()" [disabled]="!USER_EMAIL.valid">Share</button>
                    <ng-container *ngIf="(!USER_EMAIL.valid && !USER_EMAIL.untouched) && (USER_EMAIL.errors?.required || USER_EMAIL.errors?.pattern)">
                        <div *ngIf="!USER_EMAIL.errors?.required && USER_EMAIL.errors?.pattern" class="error-text">The email you entered isn’t correct. Please check your email.</div>
                    </ng-container>
                </div> -->
                <div class="form-group">
                    <div class="checkbox__wrapped" *ngIf="userService.isOrganizationUser()">
                        <label class="checkbox large m-0">
                            <input class="checkbox__input" id="share-report-modal-user-check" type='checkbox' [(ngModel)]="sharedWithOrg" (click)="shareAllOrgUser($event.target.checked)" />
                            <div class="checkbox__data pl-0">
                                <div class="checkbox__indicator"></div>
                                <p class="checkbox__text">Share with all organization users</p>
                            </div>
                        </label>
                    </div>
                </div>
            </ng-container>
            <h4 class="c-share-report-content--boxTitle">
                Below are a list of users that have <strong>{{companyName}}</strong> Report has been shared with
            </h4>


            <div class="c-share-report-no-data--wrapper" *ngIf="showLoading">
                <svg-icon name="loading-spinner" svgClass="img-fluid"></svg-icon>
            </div>
            <div class="c-share-report-no-data--wrapper" *ngIf="!selectedUsers.length && !showLoading">
                <img src="../../../../../assets/images/user-group.png" alt="User Group" class="img-fluid">
                <h4> No Individual Users</h4>
                <p class="c-share-report-no-data--content">Please choose the users above you wish to share the report
                    with.</p>
            </div>
            <div class="c-share-report-user-search-group--wrapper" *ngIf="selectedUsers.length && !showLoading">
                <ul class="c-share-report-user-search-group--list custom__scroll pl-0">
                    <li class="c-share-report-user--item" *ngFor="let sUser of selectedUsers; let i = index">
                        <div class="c-share-report-user--icon">
                            {{getInitials(sUser)}}
                        </div>
                        <h4>
                            {{sUser.NAME_FIRST}} {{sUser.NAME_LAST}}
                            <span>
                                &lt;{{sUser.EMAIL}}&gt;
                            </span>
                        </h4>
                        <div class="c-share-report-user--trasIcon" (click)="removeUser(i, sUser.ID)"
                            *ngIf="userService.checkOrganizationAdmin() || createdBy == userService.getUserId()">
                            <img src="../../../../../assets/images/trash-active.png" alt="Trash" class="img-fluid">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer border-light bg-light pt-0 c-custom-modal-footer--wrapper">
    <button type="button" id="share-report-modal-done" class="button primary__button large__button"
        (click)="confirm()">
        Ok
    </button>
</div>
